var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinancePriority3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2024_2884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6818 78.0909V75.0227C62.6818 72.9015 63.1174 70.9602 63.9886 69.1989C64.8788 67.4186 66.1667 65.9981 67.8523 64.9375C69.5568 63.858 71.6212 63.3182 74.0455 63.3182C76.5076 63.3182 78.572 63.858 80.2386 64.9375C81.9053 65.9981 83.1648 67.4186 84.017 69.1989C84.8693 70.9602 85.2955 72.9015 85.2955 75.0227V78.0909C85.2955 80.2121 84.8598 82.1629 83.9886 83.9432C83.1364 85.7045 81.8674 87.125 80.1818 88.2045C78.5152 89.2652 76.4697 89.7955 74.0455 89.7955C71.5833 89.7955 69.5095 89.2652 67.8239 88.2045C66.1383 87.125 64.8598 85.7045 63.9886 83.9432C63.1174 82.1629 62.6818 80.2121 62.6818 78.0909ZM68.4773 75.0227V78.0909C68.4773 79.8523 68.8939 81.4337 69.7273 82.8352C70.5606 84.2178 72 84.9091 74.0455 84.9091C76.0341 84.9091 77.4356 84.2178 78.25 82.8352C79.0833 81.4337 79.5 79.8523 79.5 78.0909V75.0227C79.5 73.2614 79.1023 71.6894 78.3068 70.3068C77.5114 68.9053 76.0909 68.2045 74.0455 68.2045C72.0568 68.2045 70.6269 68.9053 69.7557 70.3068C68.9034 71.6894 68.4773 73.2614 68.4773 75.0227ZM33.7045 44.7955V41.7273C33.7045 39.6061 34.1402 37.6648 35.0114 35.9034C35.9015 34.1231 37.1894 32.7027 38.875 31.642C40.5795 30.5625 42.6439 30.0227 45.0682 30.0227C47.5303 30.0227 49.5947 30.5625 51.2614 31.642C52.928 32.7027 54.1875 34.1231 55.0398 35.9034C55.892 37.6648 56.3182 39.6061 56.3182 41.7273V44.7955C56.3182 46.9167 55.8826 48.8674 55.0114 50.6477C54.1591 52.4091 52.8902 53.8295 51.2045 54.9091C49.5379 55.9697 47.4924 56.5 45.0682 56.5C42.6061 56.5 40.5322 55.9697 38.8466 54.9091C37.161 53.8295 35.8826 52.4091 35.0114 50.6477C34.1402 48.8674 33.7045 46.9167 33.7045 44.7955ZM39.5 41.7273V44.7955C39.5 46.5568 39.9167 48.1383 40.75 49.5398C41.5833 50.9223 43.0227 51.6136 45.0682 51.6136C47.0568 51.6136 48.4583 50.9223 49.2727 49.5398C50.1061 48.1383 50.5227 46.5568 50.5227 44.7955V41.7273C50.5227 39.9659 50.125 38.3939 49.3295 37.0114C48.5341 35.6098 47.1136 34.9091 45.0682 34.9091C43.0795 34.9091 41.6496 35.6098 40.7784 37.0114C39.9261 38.3939 39.5 39.9659 39.5 41.7273ZM35.8636 89L75.8636 30.8182H82.3409L42.3409 89H35.8636Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2024_2884",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2024_2884"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2024_2884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2024_2884",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancePriority3);
export default __webpack_public_path__ + "static/media/FinancePriority3.b5c97c4521181f20435ac44d3b5930c6.svg";
export { ForwardRef as ReactComponent };